import React, { useState, useEffect, useRef } from 'react'
import throttle from 'lodash.throttle'
import { withTheme, createComponent } from '@ycos/fela'
import { fullBleedStyles } from '@ycos/layout-fullbleed'
import Block from '../common/Block'

const THROTTLE_TIME = 100
const SCROLL_BAR_WIDTH = 90
const SCROLL_THUMB_WIDTH = 30

const BlockCarousel = createComponent('BlockCarousel', () => {
  return {
    width: '100%',
    overflow: 'hidden'
  }
})

const ItemWrapper = createComponent('ItemWrapper', ({ theme }) => ({
  padding: 0,
  boxSizing: 'border-box',
  width: '43vw',
  ':first-of-type': {
    marginLeft: `${theme.spacingMultiplier * 4}px`
  },
  marginRight: `${2 * theme.spacingMultiplier}px`,
  'screen-small-max': {
    ':first-of-type': {
      marginLeft: `${theme.spacingMultiplier * 2}px !important`
    },
    width: '70vw !important'
  }
}))

const SliderWrapper = createComponent(
  'SliderWrapper',
  () => {
    return {
      width: '100%',
      overflowX: 'scroll',
      scrollbarWidth: 'none',
      display: 'flex',
      flex: 1,
      '::-webkit-scrollbar': {
        display: 'none'
      }
    }
  },
  'div',
  ['ref']
)

const Slider = createComponent('Slider', () => {
  return {
    position: 'relative',
    display: 'flex',
    boxSizing: 'border-box',
    paddingLeft: 0,
    flex: '1 0 auto'
  }
})

const SliderContainer = createComponent('SliderContainer', () => {
  return {
    position: 'relative',
    display: 'block',
    width: '100%'
  }
})

const SliderPositioner = createComponent('SliderPositioner', () => {
  return {
    top: 0,
    left: 0,
    display: 'flex',
    flexWrap: 'nowrap'
  }
})

const ScrollBar = createComponent('ScrollBar', ({ theme }) => {
  return {
    width: `${SCROLL_BAR_WIDTH}px`,
    height: '3px',
    margin: `${3 * theme.spacingMultiplier}px auto 0`,
    position: 'relative',
    backgroundColor: theme.typography.colors.SecondaryGreySteel
  }
})

const ScrollThumb = createComponent('ScrollThumb', ({ theme, scrollPercentage }) => {
  const isRTL = theme.direction === 'rtl'
  const position = (isRTL ? -1 : 1) * (scrollPercentage * (SCROLL_BAR_WIDTH - SCROLL_THUMB_WIDTH)).toFixed(0)
  return {
    width: `${SCROLL_THUMB_WIDTH}px`,
    height: '3px',
    backgroundColor: theme.typography.colors.PrimaryBlack,
    position: 'absolute',
    top: 0,
    left: `${position}px`,
    transition: 'left 200ms ease 50ms'
  }
})

const MobileLayout = ({ items, imageSphere, lazy, theme }) => {
  const carouselRef = useRef(null)
  const [scrollPercentage, setScrollPercentage] = useState(0)

  const scrollHandler = throttle((event) => {
    setScrollPercentage(event.target.scrollLeft / (event.target.scrollWidth - event.target.clientWidth))
  }, THROTTLE_TIME)

  useEffect(() => {
    if (carouselRef.current) {
      carouselRef?.current.addEventListener('scroll', scrollHandler)
    }

    return () => {
      if (carouselRef.current) {
        carouselRef?.current.removeEventListener('scroll', scrollHandler)
      }
    }
  }, [carouselRef])

  return (
    <BlockCarousel style={fullBleedStyles} dir={theme.direction}>
      <SliderWrapper innerRef={carouselRef}>
        <Slider>
          <SliderContainer>
            <SliderPositioner>
              {items &&
                items.map((item, index) => {
                  return (
                    <ItemWrapper key={index}>
                      <Block item={item} imageSphere={imageSphere} imageProps={{ lazy }} />
                    </ItemWrapper>
                  )
                })}
            </SliderPositioner>
          </SliderContainer>
        </Slider>
      </SliderWrapper>
      <ScrollBar>
        <ScrollThumb scrollPercentage={scrollPercentage} />
      </ScrollBar>
    </BlockCarousel>
  )
}

export default withTheme(MobileLayout)
